"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenReplacement = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_1 = require("mobx");
var lodash_1 = require("lodash");
var classnames_1 = __importDefault(require("classnames"));
var FetchUtils_1 = require("@CommonFrontendBackend/Utils/FetchUtils");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var TokenReplacementStore_1 = require("Project/Actions/Tokens/Stores/TokenReplacementStore/TokenReplacementStore");
var TokenLoadingSpinner_1 = require("Project/Actions/Tokens/Common/TokenLoadingSpinner");
var PopularV3Tokens_1 = require("Project/Actions/Tokens/Common/PopularV3Tokens");
var ModalComponent_1 = require("@CommonFrontend/Modal/ModalComponent");
var ChangeTemplateHeading_1 = require("Project/Actions/Tokens/ChangeTemplateHeading/ChangeTemplateHeading");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var TokenReplacement = (function (_super) {
    __extends(TokenReplacement, _super);
    function TokenReplacement(props) {
        var _this = _super.call(this, props) || this;
        _this.selectedToken = null;
        _this.searchTerm = "";
        _this.renderTokenReplacementContent = function () {
            var _a = _this.props.tokenReplacementStore, providerType = _a.providerType, crmObjectType = _a.crmObjectType, currentSubstitutionTokens = _a.currentSubstitutionTokens;
            var existingTokenHeader = "existing ".concat(_this.props.existingTokensFriendlyName, " tokens");
            var newTokenHeader = "".concat(providerType, " ").concat(crmObjectType, " tokens");
            return (react_1.default.createElement("div", { className: "token-replacement__content" },
                react_1.default.createElement("div", { className: "token-replacement__header token-replacement__row" },
                    react_1.default.createElement("div", { className: "token-replacement__token-left-row" }, existingTokenHeader),
                    react_1.default.createElement("div", { className: "token-replacement__token-right-row" }, newTokenHeader)),
                currentSubstitutionTokens.map(function (existingSubstitutionToken, index) { return (react_1.default.createElement("div", { key: index, className: "token-replacement__row" },
                    _this.renderExistingToken(existingSubstitutionToken),
                    react_1.default.createElement("div", { className: "token-replacement__token-right-row  token-replacement__new-token-container", style: {
                            zIndex: currentSubstitutionTokens.length - index,
                        } },
                        _this.renderNewTokenSelection(existingSubstitutionToken),
                        (0, lodash_1.isEqual)(_this.selectedToken, existingSubstitutionToken) && _this.renderSearch(existingSubstitutionToken)))); })));
        };
        _this.renderNewTokenSelection = function (existingSubstitutionToken) {
            var _a;
            var tokenReplacementStore = _this.props.tokenReplacementStore;
            var newTokenName = (_a = tokenReplacementStore.getNewToken(existingSubstitutionToken.index)) === null || _a === void 0 ? void 0 : _a.name;
            return (react_1.default.createElement("div", { className: "token-replacement__new-token", onClick: function () { return _this.toggleSearchDropDown(existingSubstitutionToken); } },
                !!newTokenName && react_1.default.createElement(kaleidoscope_2.Token, { name: newTokenName, type: "text" }),
                react_1.default.createElement(icons_1.ChevronDown, null)));
        };
        _this.renderExistingToken = function (existingSubstitutionToken) {
            var tokenReplacementStore = _this.props.tokenReplacementStore;
            var index = tokenReplacementStore.getNewIndex(existingSubstitutionToken.index);
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)({
                    "token-replacement__token-left-row": true,
                    "token-replacement__existing-token": true,
                    "token-replacement__existing-token--complete-selection": !!index,
                }) },
                react_1.default.createElement(kaleidoscope_2.Token, { name: existingSubstitutionToken.name, type: "text" }),
                react_1.default.createElement(icons_1.ArrowRight, null)));
        };
        _this.renderSearch = function (existingSubstitutionToken) {
            return (react_1.default.createElement("div", { className: "token-replacement__search-container" },
                react_1.default.createElement("div", { className: "token-replacement__search-component" },
                    react_1.default.createElement(kaleidoscope_2.SearchInput, { label: "Find a token", placeholder: "Select a token", value: _this.searchTerm, onFocus: function () { return _this.handleOnFocus(existingSubstitutionToken); }, onClear: _this.handleSearchClear, onChange: _this.handleSearchChange })),
                react_1.default.createElement("div", { className: "token-replacement__search-result" }, _this.renderSearchResults())));
        };
        _this.renderPopularTokens = function () {
            var _a = _this.props.tokenReplacementStore, providerType = _a.providerType, crmObjectType = _a.crmObjectType, getNewIndex = _a.getNewIndex;
            var popularTokens = (0, PopularV3Tokens_1.getPopularTokens)(providerType, crmObjectType);
            if (!!popularTokens.length) {
                return popularTokens.map(function (popularToken, index) {
                    return (react_1.default.createElement(kaleidoscope_1.DropdownItem, { selected: popularToken.apiName == getNewIndex(_this.selectedToken.index), name: popularToken.apiName, key: index, onSelect: function () { return _this.onDropDownChange(_this.selectedToken, popularToken); } }));
                });
            }
        };
        _this.handleSearchChange = function (searchTerm) {
            _this.searchTerm = searchTerm;
            _this.debouncedFetchSearchResults(searchTerm);
        };
        _this.handleSearchClear = function () {
            _this.searchTerm = "";
            _this.debouncedFetchSearchResults("");
        };
        _this.fetchSearchResults = function (searchTerm) {
            _this.props.tokenReplacementStore.searchTokens(searchTerm);
        };
        _this.debouncedFetchSearchResults = (0, lodash_1.debounce)(_this.fetchSearchResults, 500, {
            trailing: true,
            leading: false,
        });
        _this.handleOnFocus = function (token) {
            _this.selectedToken = token;
        };
        _this.handleTokenReplacement = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.props.tokenReplacementStore.replaceTokens()];
                    case 1:
                        _a.sent();
                        this.props.closeModal();
                        return [2];
                }
            });
        }); };
        _this.handleModalClose = function () {
            var _a = _this.props, closeModal = _a.closeModal, tokenReplacementStore = _a.tokenReplacementStore;
            tokenReplacementStore.clearTokenReplacementSelections();
            closeModal();
        };
        _this.onClickOutside = new utils_1.OnClickOutside([".token-replacement__token-right-row"], _this.clearDropDown);
        return _this;
    }
    TokenReplacement.prototype.componentWillUnmount = function () {
        this.onClickOutside.stopListening();
    };
    TokenReplacement.prototype.render = function () {
        var _a;
        var _b = this.props, tokenReplacementStore = _b.tokenReplacementStore, existingTokensFriendlyName = _b.existingTokensFriendlyName;
        return (react_1.default.createElement("div", { className: "token-replacement" },
            react_1.default.createElement(ChangeTemplateHeading_1.ChangeTemplateHeading, { title: "Replace tokens in template", subtitle: "Replace existing ".concat(existingTokensFriendlyName, " tokens in this template with ").concat((0, lodash_1.capitalize)(tokenReplacementStore.crmObjectType), " tokens.") }),
            ((_a = tokenReplacementStore.currentSubstitutionTokens) === null || _a === void 0 ? void 0 : _a.length) > 0 && this.renderTokenReplacementContent(),
            react_1.default.createElement(ModalComponent_1.ConfirmModalButtons, { callback: this.handleModalClose, confirming: this.handleTokenReplacement, confirmLabel: "Confirm", disableConfirmButton: !tokenReplacementStore.doAllTokensHaveReplacement })));
    };
    TokenReplacement.prototype.renderSearchResults = function () {
        var _this = this;
        var _a = this.props.tokenReplacementStore, tokenSearchResults = _a.tokenSearchResults, getNewIndex = _a.getNewIndex;
        switch (tokenSearchResults.status) {
            case FetchUtils_1.RemoteDataStatus.NotRequested:
            case FetchUtils_1.RemoteDataStatus.Loading:
                return react_1.default.createElement(TokenLoadingSpinner_1.TokenLoadingSpinner, null);
            case FetchUtils_1.RemoteDataStatus.Success:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    this.renderPopularTokens(),
                    tokenSearchResults.data.map(function (crmToken, index) {
                        return (react_1.default.createElement(kaleidoscope_1.DropdownItem, { selected: crmToken.id === getNewIndex(_this.selectedToken.index) ||
                                crmToken.apiName === getNewIndex(_this.selectedToken.index), name: crmToken.name, key: index, onSelect: function () { return _this.onDropDownChange(_this.selectedToken, crmToken); } }));
                    })));
            case FetchUtils_1.RemoteDataStatus.Error:
                return react_1.default.createElement("div", { className: "token-replacement__message" }, tokenSearchResults.error.message);
            default:
                throw new Error("Unhandled token search result status");
        }
    };
    TokenReplacement.prototype.onDropDownChange = function (selectedToken, newToken) {
        this.props.tokenReplacementStore.updateTokenMap(selectedToken.index, newToken);
        this.clearDropDown();
    };
    TokenReplacement.prototype.clearDropDown = function () {
        this.selectedToken = null;
    };
    TokenReplacement.prototype.toggleSearchDropDown = function (selectedToken) {
        if (!this.selectedToken) {
            this.selectedToken = selectedToken;
            this.onClickOutside.startListening();
            return;
        }
        this.clearDropDown();
        this.onClickOutside.stopListening();
    };
    var _a, _b;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof TokenReplacementStore_1.ReplacementToken !== "undefined" && TokenReplacementStore_1.ReplacementToken) === "function" ? _a : Object)
    ], TokenReplacement.prototype, "selectedToken", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TokenReplacement.prototype, "searchTerm", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenReplacement.prototype, "handleSearchChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenReplacement.prototype, "handleSearchClear", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenReplacement.prototype, "fetchSearchResults", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TokenReplacement.prototype, "handleOnFocus", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TokenReplacement.prototype, "clearDropDown", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof TokenReplacementStore_1.ReplacementToken !== "undefined" && TokenReplacementStore_1.ReplacementToken) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], TokenReplacement.prototype, "toggleSearchDropDown", null);
    TokenReplacement = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], TokenReplacement);
    return TokenReplacement;
}(react_1.default.Component));
exports.TokenReplacement = TokenReplacement;
